import { Plus } from 'lucide-react'
import { Button, EmptyState } from '@teach/ui'
import { useMessages } from '@/i18n'
import { messages } from './messages'

/** Путь создания статьи — раздел инструкций. */
const NEW_ARTICLE_PATH = '/instructions/new'

/** «Создать статью» — раздел инструкций в НОВОЙ вкладке, открытый урок остаётся. */
export const CreateArticleButton = ({ className }: { className?: string }) => {
  const m = useMessages(messages)
  return (
    <Button
      size="sm"
      className={className}
      onClick={() => window.open(NEW_ARTICLE_PATH, '_blank', 'noopener')}
    >
      <Plus className="mr-1.5 size-4" />
      {m.createArticle}
    </Button>
  )
}

/**
 * Опубликованных статей нет: жёлтый маскот «пусто» из дизайн-системы и «Создать
 * статью» — в НОВОЙ вкладке, чтобы не потерять открытый урок.
 * Столбиком (`layout="stack"`): панель блока и экран урока узкие.
 */
export const ArticlesEmpty = () => {
  const m = useMessages(messages)
  return (
    <EmptyState
      layout="stack"
      title={m.emptyTitle}
      description={m.emptyDescription}
      action={<CreateArticleButton />}
    />
  )
}
